import { Point } from './Point';
import { LineString } from './LineString';
import { Polygon } from './Polygon';

export class MultiPoint {
  public coordinates: [number, number][];
  public type: 'MultiPoint' = 'MultiPoint';

  constructor(coordinates: [number, number][]) {
    this.coordinates = coordinates.map((c) => [...c] as [number, number]);
  }

  getPoints(): Point[] {
    return this.coordinates.map((c) => new Point(c));
  }

  getPoint(index: number): Point {
    return new Point(this.coordinates[index]);
  }

  toGeoJSON(): GeoJSON.MultiPoint {
    return { type: 'MultiPoint', coordinates: this.coordinates };
  }
}

export class MultiLineString {
  public coordinates: [number, number][][];
  public type: 'MultiLineString' = 'MultiLineString';

  constructor(coordinates: [number, number][][]) {
    this.coordinates = coordinates.map((line) =>
      line.map((c) => [...c] as [number, number])
    );
  }

  getLineStrings(): LineString[] {
    return this.coordinates.map((c) => new LineString(c));
  }

  getLineString(index: number): LineString {
    return new LineString(this.coordinates[index]);
  }

  toGeoJSON(): GeoJSON.MultiLineString {
    return { type: 'MultiLineString', coordinates: this.coordinates };
  }
}

export class MultiPolygon {
  public coordinates: [number, number][][][];
  public type: 'MultiPolygon' = 'MultiPolygon';

  constructor(coordinates: [number, number][][][]) {
    this.coordinates = coordinates.map((poly) =>
      poly.map((ring) => ring.map((c) => [...c] as [number, number]))
    );
  }

  getPolygons(): Polygon[] {
    return this.coordinates.map((c) => new Polygon(c));
  }

  getPolygon(index: number): Polygon {
    return new Polygon(this.coordinates[index]);
  }

  toGeoJSON(): GeoJSON.MultiPolygon {
    return { type: 'MultiPolygon', coordinates: this.coordinates };
  }
}

export type Geometry = Point | LineString | Polygon | MultiPoint | MultiLineString | MultiPolygon;

export class GeometryCollection {
  private geometries: Geometry[];

  constructor(geometries: Geometry[] = []) {
    this.geometries = [...geometries];
  }

  getGeometries(): Geometry[] {
    return [...this.geometries];
  }

  getGeometry(index: number): Geometry {
    return this.geometries[index];
  }

  isEmpty(): boolean {
    return this.geometries.length === 0;
  }
}
